import React, { useEffect } from 'react'
import { navigate } from '@reach/router'
import { useTranslation } from 'react-i18next'
import Button from '../Button'
import { datadogLogs } from '@datadog/browser-logs'
import { localizePath } from '../helpers/locale'

export default function NotFound({ children }) {
  const { t } = useTranslation()
  useEffect(() => {
    datadogLogs.logger.warn('NotFound: 404 Not Found')
  }, [])

  return (
    <div className="center tc moon-gray lh-title">
      <p className="f1 b mt3 mb3">
        <span className="ph1 light-gray">?</span>
        <span className="ph1 silver">?</span>
        <span className="ph1 moon-gray">?</span>
        <span className="ph1 silver">?</span>
        <span className="ph1 light-gray">?</span>
      </p>
      <p className="mt0 mb3">{children || t('notFound.message')}</p>
      <p className="mt0 mb3">
        <Button onClick={() => navigate(localizePath('/'))}>
          {t('notFound.goToFrontPage')}
        </Button>
      </p>
    </div>
  )
}
